import { ModuleProps, CreateModuleProps } from "components";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_PREFERENCES",
    parentId: "SETTINGS_PARENT",
    applicationRights: [],
    title: 'Preferanser',
    text: 'Preferanser',
    icon: 'gear',
    showOnDashboardByDefault: false,
    url: "/settings/PREFERENCES"
})
